import * as _ from 'underscore';
import React from 'react';
import ReactDom from 'react-dom';

import { TextField } from '@material-ui/core';
import Button from 'material-ui/Button';

import ExercisePlain from './Exercise/ExercisePlain';
import DropSimple from './DropSimple';
import Drop from './Drop';
import TextArea from './TextArea';
import MDTag from './/MegaDrop/MegaDropTag';

import * as DesignerState from '../../../state/reducer/designer/designer';
import { redzoneTypes } from '../../../lib/paramTypes';
import { getBlockTitle } from '../../../lib/designerUtils';

import Console from '../../../lib/debug';

export default class CircuitCreate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            titleUsed: false,
            disableButtons: false
        };
        this.videosWrapperRef = React.createRef();
    }

    componentWillMount() {
        let defaults = {
            eType: 'wc',
            can_edit: 1,
            plain_text: 1,
            param_1_type: null,
            param_2_type: null,
            points_of_performance: '',
            video_url: '',
            tags: [],
            exercises: [],
            titleUsed: this.isTitleUsed(this.props.combo.title)
        };
        this.setState(() => ({
            ...defaults,
            ...this.props.combo
        }));
    }

    getFilteredExerciseRef() {
        let blockExercises = [];
        _.map(this.props.exerciseTree, ex => {
            if (
                this.props.block &&
                this.props.block.exerciseKeys.indexOf(ex.id) >= 0
            ) {
                blockExercises.push(ex);
            }
        });
        let exerciseIds = _.pluck(blockExercises, 'exercise_id');
        return this.props.exerciseRef.filter(ex => {
            return exerciseIds.indexOf(ex.id) < 0;
        });
    }

    handleChange(key, e) {
        let value = e.currentTarget.value;
        let newState = {
            [key]: value,
            titleUsed: false
        };
        if (key === 'title') {
            let titleUsed = this.isTitleUsed(value);
            if (titleUsed) {
                newState = {
                    ...newState,
                    titleUsed
                };
            }
        }
        this.setState(() => newState);
    }

    handleChangeLeaderboard(leaderboard) {
        this.setState(() => ({
            redzone_type: leaderboard.id,
            is_redzone: leaderboard.id > 0 ? 1 : 0
        }));
    }

    handleChangeTags(tags) {
        this.setState(() => ({
            tags
        }));
    }

    onNewCircuitExerciseTag(tag) {
        // Create tag if its not created
        let tags = [...this.state.tags];
        if (typeof tag.id !== 'number') {
            DesignerState.createTag(tag.title);
        }
        tag.id = 'updated';
        tags.push(tag);
        this.setState(() => ({
            tags
        }));
    }

    handleExerciseAdd(exercise) {
        var block = this.state;
        DesignerState.createSetExercise(block, exercise);
    }

    handleExerciseDelete(exercise) {
        var block = this.props.combo.length ? this.props.combo : this.state;
        DesignerState.savingState(block, true);
        DesignerState.deleteExercise(block, exercise);
    }

    handleSave(block) {
        for (var i = 0; i < this.state.tags.length; i++) {
            if (typeof this.state.tags[i].id !== 'number') {
                for (var j = 0; j < this.props.exerciseTags.length; j++) {
                    if (
                        this.props.exerciseTags[j].title ===
                        this.state.tags[i].title
                    ) {
                        this.state.tags[i] = this.props.exerciseTags[j];
                    }
                }
            }
        }
        let exercises = block.exercises.map(ex => {
            let _ex = ex;
            if (typeof ex === 'number') {
                _ex = this.props.exerciseTree[ex];
            }
            return _ex;
        });
        let circuitData = {
            ...this.state,
            exerciseKeys: block.exerciseKeys,
            exercises
        };
        this.props.onSave(circuitData);
    }

    isTitleUsed(title) {
        let existingCircuit = _.find(this.props.exerciseBenchmarkRef, {
            title: title
        });
        return !!existingCircuit;
    }

    disableButtons = () => {
        let newState = {
            ...newState,
            disableButtons: false
        };
        this.setState(() => newState);
    };

    lockEvents = () => {
        let newState = {
            ...newState,
            disableButtons: true
        };
        this.setState(() => newState);
    };

    scrollToBottom = () => {
        let newState = {
            ...newState,
            disableButtons: true
        };
        this.setState(() => newState);
        const node = ReactDom.findDOMNode(this.bottomDrawerCircuit);
        node.scrollIntoView({ behavior: 'smooth' });
    };

    render() {
        Console.render('designer.CircuitCreate');
        let combo = Object.keys(this.state).length
            ? this.state
            : this.props.combo;
        let block = this.props.combo ? this.props.combo : combo;
        let isCircuit = combo.plain_text === 1;
        let exercises = null;
        let isSidenav = this.props.isSidenav || false;
        let isEditable = combo.can_edit === 1 ? true : false;
        let cancelLabel = 'Cancel';
        let exerciseRef = this.getFilteredExerciseRef();
        if (isCircuit) {
            exercises = block.exercises.length
                ? block.exercises.map((ex, i) => {
                      if (typeof ex === 'number') {
                          ex = this.props.exerciseTree[ex];
                      }
                      let id = ex.id || ex.exercise_id;
                      return (
                          <ExercisePlain
                              key={`video-${id}`}
                              exercise={ex}
                              position={i}
                              hideDelete={!isEditable}
                              isInCircuitBuilder={true}
                              videosWrapperRef={this.videosWrapperRef}
                              onDelete={this.handleExerciseDelete.bind(this)}
                          />
                      );
                  })
                : [];
        } else {
            exercises = combo.exercises.length ? (
                combo.exercises.map((ex, i) => (
                    <li key={`ex-${ex.id}`} className="exercise-item">
                        <span className="exercise-subtitle">
                            {getBlockTitle(i)}
                        </span>
                        {ex.title}
                        <i
                            className={`mdi mdi-close${
                                isEditable ? ' hide' : ''
                            }`}
                            onClick={this.handleExerciseDelete.bind(this, ex)}
                        />
                    </li>
                ))
            ) : (
                <p>
                    <em>Select exercises</em>
                </p>
            );
        }
        if (isSidenav) cancelLabel = 'Close';
        let titleContent = null;
        let titleContentError = null;
        let instructionsContent = null;
        let resultsContent = null;
        let tagsContent = null;
        let exercisesContent = null;
        let saveButton = null;
        if (isEditable) {
            cancelLabel = 'Cancel';
            titleContent = (
                <TextField
                    id="title"
                    label="Title"
                    autoFocus
                    fullWidth
                    value={this.state.title}
                    onChange={ev => this.handleChange('title', ev)}
                    margin="normal"
                    variant="outlined"
                />
            );

            titleContentError = this.state.titleUsed ? (
                <p className="error-label">This name is already used</p>
            ) : null;
            instructionsContent = (
                <TextArea
                    value={this.state.instruction}
                    blurCallback={this.handleChange.bind(this, 'instruction')}
                />
            );
            resultsContent = (
                <DropSimple
                    name="leaderboard"
                    value={this.state.redzone_type}
                    multi={false}
                    options={redzoneTypes}
                    placeholder="Select Units"
                    clearable={false}
                    onChange={this.handleChangeLeaderboard.bind(this)}
                    labelKey="title"
                    valueKey="id"
                    onOpen={this.lockEvents.bind(this)}
                    disableButtons={this.disableButtons.bind(this)}
                />
            );
            tagsContent = (
                <Drop
                    name="exercise-tags"
                    value={this.state.tags}
                    multi={true}
                    options={this.props.exerciseTags}
                    placeholder="Select tags or type your own"
                    onChange={this.handleChangeTags.bind(this)}
                    onNewOptionClick={this.onNewCircuitExerciseTag.bind(this)}
                    labelKey="title"
                    valueKey="id"
                    onOpen={this.scrollToBottom.bind(this)}
                    disableButtons={this.disableButtons.bind(this)}
                />
            );
            exercisesContent = (
                <DropSimple
                    placeholder={`Select ${
                        isCircuit ? 'Video(s)' : 'Exercise(s)'
                    }`}
                    options={exerciseRef}
                    clearable={false}
                    openOnFocus={true}
                    onChange={this.handleExerciseAdd.bind(this)}
                    labelKey="title"
                    valueKey="id"
                    onOpen={this.scrollToBottom.bind(this)}
                    disableButtons={this.disableButtons.bind(this)}
                />
            );
            saveButton = (
                <Button
                    color="primary"
                    variant="raised"
                    disabled={this.state.title === '' || this.state.titleUsed}
                    onClick={this.handleSave.bind(this, block)}
                >
                    {isCircuit ? 'Save Circuit' : 'Save Superset'}
                </Button>
            );
        } else {
            titleContent = <p>{this.state.title}</p>;
            instructionsContent = this.state.instruction ? (
                <pre>{this.state.instruction}</pre>
            ) : (
                <p>
                    <em>No instructions available</em>
                </p>
            );
            resultsContent = (
                <p>{_.find(redzoneTypes, { id: combo.redzone_type }).title}</p>
            );
            tagsContent = combo.tags.length ? (
                combo.tags.map(t => <MDTag key={`${t.id}`} tag={t} />)
            ) : (
                <p>
                    <em>No tags available</em>
                </p>
            );
        }
        return (
            <div className="create-dialog edit-combo-dialog layout-column">
                <div className="dialog-body">
                    <div className="input-group">
                        {titleContent}
                        {titleContentError}
                    </div>
                    <div className="input-group">
                        <label>Instructions</label>
                        {instructionsContent}
                    </div>
                    <div className="input-group">
                        <label>Results</label>
                        {resultsContent}
                    </div>
                    <div className="tags input-group">
                        <label>Tags</label>
                        {tagsContent}
                    </div>
                    <div className="videos input-group">
                        <label>{isCircuit ? 'Videos' : 'Exercises'}</label>
                        {exercisesContent}
                        <div
                            className={`videos-wrapper${
                                exercises.length > 4 ? ' reorder' : ''
                            }`}
                            ref={this.videosWrapperRef}
                        >
                            {exercises}
                        </div>
                    </div>
                    <div
                        style={{ float: 'left', clear: 'both' }}
                        ref={el => {
                            this.bottomDrawerCircuit = el;
                        }}
                    />
                </div>
                <div className="dialog-footer">
                    <Button
                        onClick={this.props.onClose}
                        disabled={this.state.disableButtons}
                    >
                        {cancelLabel}
                    </Button>
                    {saveButton}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/designer/components/CircuitCreate.jsx